import { render, staticRenderFns } from "./EncuestaSatisfaccion.vue?vue&type=template&id=fa06635e&scoped=true"
import script from "./EncuestaSatisfaccion.vue?vue&type=script&lang=js"
export * from "./EncuestaSatisfaccion.vue?vue&type=script&lang=js"
import style0 from "./EncuestaSatisfaccion.vue?vue&type=style&index=0&id=fa06635e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa06635e",
  null
  
)

export default component.exports